/**
 * Created by Suhel Shrestha on 9/16/21
 */

import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import { checkRolePermission } from '../../libs/checkPermission';
import TabBar from '../TabBar';

import System from "./System/System";

import LocationTypeList from '../Location/LocationTypeList';
import LocationList from '../Location/LocationList';
import LocationTree from '../Location/LocationTree';

import MetaDataList from '../MetaData/MetaDataList';
import MetaDataModify from '../MetaData/MetaDataModify';
import MetaDataTemplateList from '../MetaDataTemplate/MetaDataTemplateList';
import MetaDataTemplateAdd from '../MetaDataTemplate/MetaDataTemplateAdd';
import MetaDataTemplateEdit from '../MetaDataTemplate/MetaDataTemplateEdit';

import StationTypeList from '../Station/Type/StationTypeList'
import LocationModify from '../Location/LocationModify';
import LocationTypeModify from '../Location/LocationTypeModify';
import StationTypeModify from '../Station/Type/StationTypeModify';
import ServerList from './Server/ServerList';
import ServerModify from './Server/ServerModify';
import { ENABLE_AGG_FEATURES } from '../../config';

const ConfigurationsWrapper = props => (
  <div className='inner-section-root'>
    <TabBar
      key={"configurations"}
      items={[
        ...[
          { label: 'System', to: `/configurations/system` },
          { label: 'Location', to: `/configurations/location` },
          { label: 'Station Type', to: `/configurations/station-type` },
          { label: 'Meta Data', to: `/configurations/meta-data` },

          // { label: 'Reporting', to: `/configurations/reporting` },
        ],
        ...(ENABLE_AGG_FEATURES ? [{ label: 'Server', to: `/configurations/server` }] : []),
      ]}
    />
    <div className='inner-section-content'>
      {props.children}
    </div>
  </div>
);

const LocationWrapper = props => (
  <div>
    <TabBar
      items={[
        { to: '/configurations/location/station-location', label: 'Location' },
        { to: '/configurations/location/location-type', label: 'Location Type' },
        { to: '/configurations/location/location-tree', label: 'Location Tree' },
      ]}
    /><br />
    {props.children}
  </div>
)

const MetaDataWrapper = props => (
  <div>
    <TabBar
      items={[
        { to: '/configurations/meta-data/meta-data', label: 'Meta Data' },
        { to: '/configurations/meta-data/template', label: 'Meta Data Template' },
      ]}
    /><br />
    {props.children}
  </div>
)

export const ConfigurationRoute = () => (
  <Route name={'view configurations'} component={checkRolePermission(ConfigurationsWrapper)}>
    <IndexRedirect to='system' />
    <Route path='system' component={System} />

    <Route path='location' component={LocationWrapper}>
      <IndexRedirect to='station-location' />
      <Route path='station-location' component={LocationList}>
        <Route path=':id' component={LocationModify} />
      </Route>
      <Route path='location-type' component={LocationTypeList}>
        <Route path=':id' component={LocationTypeModify} />
      </Route>
      <Route path='location-tree' component={LocationTree} >
        <Route path=':id' component={LocationModify} />
      </Route>
    </Route>

    <Route path='station-type' component={StationTypeList}>
      <Route path=':id' component={StationTypeModify} />
    </Route>

    <Route path='meta-data' component={MetaDataWrapper}>
      <IndexRedirect to='meta-data' />
      <Route path="meta-data" component={checkRolePermission(MetaDataList)} name="view meta-data">
        <Route path=":id" component={checkRolePermission(MetaDataModify)} name="modify meta-data" />
      </Route>

      <Route path="template" component={checkRolePermission(MetaDataTemplateList)}>
        <Route path="add" component={checkRolePermission(MetaDataTemplateAdd)} name='modify meta-data-template' />
        <Route path=":id" component={checkRolePermission(MetaDataTemplateEdit)} name='modify meta-data-template' />
      </Route>
    </Route>

   {ENABLE_AGG_FEATURES && <Route path='server' component={ServerList} >
      <Route path=':id' component={ServerModify} />
    </Route>}

  </Route>
);



// WEBPACK FOOTER //
// ./src/components/SystemConfiguration/routes.js